// extracted by mini-css-extract-plugin
module.exports = {"MyPost":"_3slF02VXpNrgyYpnNUFn30"};